import {
  type UseSelectFilterLogicProps,
  useSelectFilterLogic,
} from "~/GearboxSelectionAssistant/components/CharacteristicsFilter/components/useSelectFilterLogic";

import classes from "./RadioFilter.module.less";
import classNames from "classnames";
import { SimpleRadio } from "~/common/components/Radio";

type Props = Omit<UseSelectFilterLogicProps, "multiselect"> & {
  className?: string;
};

export const RadioFilter = ({ className, ...rest }: Props) => {
  const { name, items, makeOnClick, trackingCode } = useSelectFilterLogic({ ...rest, multiselect: false });
  const value = rest.value[0] ?? null;

  return (
    <div className={classNames(className, classes.root)}>
      <label className={classes.name}>{name}</label>
      <ol className={classes.list} tracking-aux-section-marker={trackingCode}>
        {items.map((item, index) => (
          <li key={index} className={classes.listItem}>
            <SimpleRadio
              onClick={makeOnClick(item.code)}
              checked={value === item.code}
              disabled={item.disabled}
              inputProps={{ "tracking-aux-option-marker": item.trackingCode }}
            />
            <label>{item.name}</label>
          </li>
        ))}
      </ol>
    </div>
  );
};
